/* Beat My Quote: two-step private upload. Success is shown only after the enquiry service confirms durable storage. */
(() => {
  "use strict";
  const C = (window.Caelverne = window.Caelverne || {});
  const MAX = 8 * 1024 * 1024, TYPES = ["application/pdf", "image/jpeg", "image/png", "image/webp"];
  let state = null;

  function setup() {
    const wrap = document.querySelector('[data-cv-dialog="quote"]');
    if (!wrap) return;
    const $ = sel => wrap.querySelector(sel);
    const text = JSON.parse($("[data-quote-text]").textContent);
    const step1 = $('form[data-step="1"]'), step2 = $('form[data-step="2"]');
    const errorEl = $("[data-error]"), notice = $("[data-disabled-notice]"), desc = $("#quote-description");
    const fileInput = $("#quote-attachment"), fileLabel = $("[data-file-label]"), removeBtn = $("[data-remove-file]");
    const consent = $("#quote-consent"), submitBtn = step2.querySelector("[data-submit]");
    state = { file: null, preview: "", requestId: C.uuid(), pending: false, step: 1 };

    const showError = msg => { errorEl.textContent = msg || ""; errorEl.hidden = !msg; if (msg) errorEl.focus({ preventScroll: false }); };
    const showNotice = msg => { notice.textContent = msg || ""; notice.hidden = !msg; };
    const goStep = n => {
      state.step = n; step1.hidden = n !== 1; step2.hidden = n !== 2;
      desc.textContent = n === 1 ? desc.dataset.step1 : desc.dataset.step2;
      wrap.querySelectorAll("[data-progress]").forEach(p => p.classList.toggle("active", p.dataset.progress === String(n)));
      renderPreview();
      (n === 1 ? $("#jeweller") : $("#full-name")).focus();
    };
    const size = b => (b >= 1048576 ? `${(b / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(b / 1024))} KB`);
    function renderPreview() {
      wrap.querySelectorAll("[data-preview-slot]").forEach(slot => (slot.innerHTML = ""));
      if (!state.file) return;
      const slot = (state.step === 1 ? step1 : step2).querySelector("[data-preview-slot]");
      const node = $("[data-tpl-preview]").content.cloneNode(true);
      const media = node.querySelector("[data-media]");
      if (state.preview) { const img = document.createElement("img"); img.src = state.preview; img.alt = "Preview of your attached quote"; media.replaceWith(img); }
      else media.replaceWith($("[data-tpl-pdf]").content.cloneNode(true));
      node.querySelector("[data-name]").textContent = state.file.name;
      node.querySelector("[data-meta]").textContent = `${size(state.file.size)} · ${text.ready}`;
      node.querySelector("[data-next]").textContent = state.step === 1 ? text.next1 : text.next2;
      slot.appendChild(node);
    }
    const setFile = f => {
      if (state.preview) URL.revokeObjectURL(state.preview);
      state.file = f; state.preview = f && f.type.startsWith("image/") ? URL.createObjectURL(f) : "";
      fileLabel.textContent = f ? f.name : fileLabel.dataset.empty; removeBtn.hidden = !f; renderPreview();
    };
    fileInput.addEventListener("change", () => {
      showError(""); const f = fileInput.files && fileInput.files[0]; fileInput.value = "";
      if (!f) return;
      if (f.size > MAX) return showError(text.size);
      const typeOk = f.type ? TYPES.includes(f.type) : /\.(pdf|jpe?g|png|webp)$/i.test(f.name);
      if (!typeOk) return showError(text.type);
      setFile(f);
    });
    removeBtn.addEventListener("click", () => { setFile(null); fileInput.focus(); });
    consent.addEventListener("change", () => (consent.dataset.state = consent.checked ? "checked" : "unchecked"));
    $("#quote-marketing")?.addEventListener("change", e => (e.target.dataset.state = e.target.checked ? "checked" : "unchecked"));

    step1.addEventListener("submit", e => {
      e.preventDefault(); showError("");
      const j = $("#jeweller").value.trim(), p = $("#quoted-price").value.trim(), n = $("#ring-notes").value.trim();
      if (!j || !/^\d{1,8}(\.\d{1,2})?$/.test(p) || Number(p) <= 0 || n.length < 5) return showError(text.step1);
      goStep(2);
    });
    step2.querySelector("[data-back]").addEventListener("click", () => { showError(""); goStep(1); });
    step2.addEventListener("submit", async e => {
      e.preventDefault(); if (state.pending) return; showError(""); showNotice("");
      const name = $("#full-name").value.trim(), email = $("#email").value.trim();
      if (name.length < 2 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return showError(text.step2);
      if (!consent.checked) return showError(text.consent);
      if (!C.enquiriesEnabled) return showNotice(C.disabledMessage);
      const form = new FormData();
      Object.entries({ requestId: state.requestId, type: "comparison", budget: "", notes: $("#ring-notes").value.trim(), name, email, phone: $("#phone").value.trim(), inspiration: state.inspiration || "", jeweller: $("#jeweller").value.trim(), quotedPrice: $("#quoted-price").value.trim(), currency: $("#quote-currency").value, website: $("#quote-website").value, consent: "yes" }).forEach(([k, v]) => form.set(k, v));
      if (state.file) form.set("attachment", state.file);
      form.set("sourceUrl", C.sourceUrl()); form.set("attribution", JSON.stringify(C.attribution() || {}));
      const mk = $("#quote-marketing"); form.set("marketingConsent", mk && mk.checked ? "yes" : "");
      state.pending = true; submitBtn.disabled = true; submitBtn.querySelector("[data-idle]").hidden = true; submitBtn.querySelector("[data-busy]").hidden = false; step2.querySelector("[data-back]").disabled = true;
      try {
        const { res, data } = await C.api("private-quotes", { method: "POST", body: form });
        if (!res.ok || typeof data.reference !== "string" || !/^CD-[0-9A-F]{10}$/.test(data.reference)) {
          if (data.field && ["attachment", "jeweller", "quotedPrice", "currency", "notes"].includes(data.field)) goStep(1);
          throw new Error(data.error || text.generic);
        }
        $("[data-reference]").textContent = data.reference; $("[data-email]").textContent = email;
        $('[data-view="form"]').hidden = true; $('[data-view="success"]').hidden = false;
        $('[data-view="success"] button').focus();
        state.done = true;
      } catch (err) {
        if (err instanceof C.ServiceDisabled) showNotice(err.message);
        else showError(err instanceof TypeError ? text.network : err.message || text.generic);
      } finally {
        state.pending = false; submitBtn.disabled = false; submitBtn.querySelector("[data-idle]").hidden = false; submitBtn.querySelector("[data-busy]").hidden = true; step2.querySelector("[data-back]").disabled = false;
      }
    });

    const reset = () => {
      step1.reset(); step2.reset(); setFile(null); consent.dataset.state = "unchecked"; const mk = $("#quote-marketing"); if (mk) mk.dataset.state = "unchecked"; showError(""); showNotice("");
      $('[data-view="form"]').hidden = false; $('[data-view="success"]').hidden = true;
      state.requestId = C.uuid(); state.done = false; state.inspiration = "";
    };
    // Entered details survive an accidental close; a completed request starts fresh next time.
    C.openQuote = (inspiration, opener) => {
      if (state.done) reset();
      if (inspiration && inspiration !== state.inspiration) { state.inspiration = inspiration; const notes = $("#ring-notes"); if (!notes.value.trim()) notes.value = text.interest.replace("[ring]", inspiration); }
      if (!C.enquiriesEnabled) showNotice(C.disabledMessage); else showNotice("");
      C.dialogs.open("quote", opener);
      requestAnimationFrame(() => (state.step === 1 ? $("#jeweller") : $("#full-name")).focus());
    };
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", setup); else setup();
})();
